"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Enum_1 = require("../enum/Enum");
var MesaColorEnum = (function (_super) {
    __extends(MesaColorEnum, _super);
    function MesaColorEnum(keyClassName, rgba, hex) {
        var _this = _super.call(this) || this;
        _this.keyClassName = keyClassName;
        _this.rgba = rgba;
        _this.hex = hex;
        return _this;
    }
    Object.defineProperty(MesaColorEnum.prototype, "backgroundClassName", {
        get: function () {
            return "background-color--" + this.keyClassName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MesaColorEnum.prototype, "borderClassName", {
        get: function () {
            return "border-color--" + this.keyClassName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MesaColorEnum.prototype, "fontClassName", {
        get: function () {
            return "font-color--" + this.keyClassName;
        },
        enumerable: true,
        configurable: true
    });
    MesaColorEnum.asObject = function () {
        return _super.asObject.call(this);
    };
    MesaColorEnum.asArray = function () {
        return _super.asArray.call(this);
    };
    MesaColorEnum.WHITE = new MesaColorEnum("white", "rgba(255,255,255, 1)", "#FFFFFF");
    MesaColorEnum.SNOW = new MesaColorEnum("snow", "rgba(246,247,249, 1)", "#F6F7F9");
    MesaColorEnum.SILVER = new MesaColorEnum("silver", "rgba(211,216,221, 1)", "#D3D8DD");
    MesaColorEnum.GRAY = new MesaColorEnum("gray", "rgba(46,62,79, 1)", "#9AA4AF");
    MesaColorEnum.NAVY = new MesaColorEnum("navy", "rgba(46,62,79, 1)", "#2E3E4F");
    MesaColorEnum.ORANGE = new MesaColorEnum("orange", "rgba(218,91,65, 1)", " #DA5B41");
    MesaColorEnum.MIDNIGHT = new MesaColorEnum("midnight", "rgba(19,36,52, 1)", "#132434");
    MesaColorEnum.GOLD = new MesaColorEnum("gold", "rgba(232,159,116, 1)", "#E89f74");
    MesaColorEnum.BRICK = new MesaColorEnum("brick", "rgba(199, 83, 60, 1)", "#C7533C");
    MesaColorEnum.RED = new MesaColorEnum("red", "rgba(185,43,44, 1)", "#B92B2C");
    MesaColorEnum.SEAFOAM = new MesaColorEnum("seafoam", "rgba(0,169,157, 1)", "#00A99D");
    MesaColorEnum.GREEN = new MesaColorEnum("green", "rgba(92,184,92, 1)", "#5CB85C");
    MesaColorEnum.EMERALD = new MesaColorEnum("emerald", "rgba(68,157,68, 1)", "#5CB85C");
    MesaColorEnum.BLUE = new MesaColorEnum("blue", "rgba(93,156,236, 1)", "#5D9CEC");
    MesaColorEnum.APPLE = new MesaColorEnum("apple", "rgba(169, 40, 40, 1)", "#A92828");
    MesaColorEnum.DARK_BLUE = new MesaColorEnum("dark-blue", "rgba(95, 106, 190, 1)", "#5F6ABE");
    return MesaColorEnum;
}(Enum_1.Enum));
exports.MesaColorEnum = MesaColorEnum;
